import { render, staticRenderFns } from "./KatalogDetail.vue?vue&type=template&id=93e5b070&scoped=true&"
import script from "./KatalogDetail.vue?vue&type=script&lang=js&"
export * from "./KatalogDetail.vue?vue&type=script&lang=js&"
import style0 from "./KatalogDetail.vue?vue&type=style&index=0&id=93e5b070&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93e5b070",
  null
  
)

export default component.exports